export enum Sexuality {
  Straight,
  Homosexual,
  Bisexual,
  Other,
  NotSpecified
}
